module.exports = __webpack_public_path__ + "static/media/daequan.5c5f02da.mp3";